export function getPageTitle() {
  const routeName = useRoute().name;
  // @ts-ignore
  return `${capitalize(routeName)} | SmartComm Call Center`;
}

function capitalize(str: string): string {
  const cleanedRoute = str.replace(/index|pages/g, "");
  return cleanedRoute.replace(/-/g, " ");
}

export function formatDateTime(inputDateString: string) {
  const inputDate = new Date(inputDateString);

  // Create an array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const year = inputDate.getFullYear();
  const month = monthNames[inputDate.getMonth()];
  const day = inputDate.getDate();

  let hours = inputDate.getHours();
  const minutes = inputDate.getMinutes();
  const seconds = inputDate.getSeconds();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

  return `${day} ${month} ${year} ${hours}:${minutes}:${seconds} ${ampm}`;
}
